export function getRowHeight(setState) {
  const userListRowEl = document.getElementById("user-list-row");
  const windowHeight = window.innerHeight;
  if (userListRowEl) {
    const userListRowElOffsets = userListRowEl.getBoundingClientRect();

    setState(windowHeight - userListRowElOffsets.top - 15);
  }
}

export function getMaxContainerHeight({ screens }) {
  const userListRowEl = document.getElementById("user-list-row");
  const windowHeight = window.innerHeight;
  if (userListRowEl) {
    const userListRowElOffsets = userListRowEl.getBoundingClientRect();

    return windowHeight - userListRowElOffsets.top - 25;
  } else {
    return windowHeight;
  }
}
